import { SimpleTranslate, useLocale } from '@b2c/hooks';
import { RatePlanHelper } from '@b2c/services/rateplan';
import { useMemo } from 'react';
import { Tag, Typography } from 'react-vant';
import { TagSize } from 'react-vant/es/tag/PropsType';
import { TypographyTextProps } from 'react-vant/es/typography/PropsType';

export function TypographyConfirmTime({
  delay,
  tagMode,
  tagSize,
  noColor,
  ...props
}: {
  delay: number;
  noColor?: boolean;
  tagMode?: boolean;
  tagSize?: TagSize;
} & Omit<TypographyTextProps, 'type'>) {
  const t = useLocale();

  const delayHour = useMemo(() => {
    return (
      delay && RatePlanHelper.calculateOnRequestLimitTimeInHour(delay, 0.5)
    );
  }, [delay]);

  const type = delay ? 'warning' : 'success';
  const tagType = noColor ? 'default' : type;

  const tagText = buildConfirmTimeDesc(delayHour, t);

  const render = () => {
    if (noColor) {
      return <>{tagText}</>;
    }
    return (
      <Typography.Text type={type} {...props}>
        {tagText}
      </Typography.Text>
    );
  };

  if (tagMode) {
    return (
      <Tag type={tagType} plain size={tagSize ?? 'medium'}>
        {render()}
      </Tag>
    );
  }

  return render();
}

export function buildConfirmTimeDesc(delayHour: number, t: SimpleTranslate) {
  const tagText = delayHour
    ? t('Label_RatePlan_OnRequest', {
        hours: delayHour,
      })
    : t('Label_RatePlan_ImmediateConfirm');
    return tagText;
}